import styled from 'styled-components';
import useTranslation from '../../../../hooks/useTranslation';

import { Tag } from '../../../generic/Core';
import Checkbox from '../../../generic/CheckBox';

const ListContainer = styled.div`
    width: 100%;
    padding: 0rem;
`;

export const ListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
    border-bottom: 1px solid ${props => props.theme.table.border};
    font-weight: bold;
`;

export const ListRow = styled.div`
    display: flex;
    min-height: 3rem;
    justify-content: space-between;
    padding: 0.5rem;
    border-bottom: 1px solid ${props => props.theme.table.border};
    cursor: pointer;
    background-color: ${props => props.selected ? props.theme.table.background : 'transparent'};
    
    &:hover {
        background-color: ${props => props.theme.table.hover};
    }
`;

export const ListCol = styled.div`
    flex: ${props => props.$flex || '1'};
    margin: ${props => props.$margin || '0'}; 
    display: flex;
    align-items: center;
    font-size: var(--font-XS);
`;


const BaseList = ({
    columns = ['Location', 'Quantity'],
    emptyMessage,
    data = [],
    biData = [],
    selectedItems = [],
    isItemSelectable = true,
    handleSelection,
    getTagValue,
    testId
}) => {
 
    const { t } = useTranslation()

    // Guard against null/undefined data arrays
    const safeData = Array.isArray(data) ? data : [];
    const safeBiData = Array.isArray(biData) ? biData : [];
    const safeColumns = Array.isArray(columns) ? columns : [];
    const safeSelectedItems = Array.isArray(selectedItems) ? selectedItems : [];
 
    //console.log('[i] Data: ', data)
 
    return (
        <ListContainer>
            <ListHeader>
                {safeColumns.map((col, key) => (
                    <ListCol $flex={col?.flex} $margin={col?.margin} key={key}>
                        {t(col?.title ?? '')}
                    </ListCol>
                ))}
            </ListHeader>
            {(safeData.length === 0 && safeBiData.length === 0) &&
                <ListRow><span>{t(emptyMessage)}</span></ListRow>
            }
            {safeData.map((item, key) => (
                <ListRow
                    key={key}
                    selected={safeSelectedItems.some(selected => selected?.id === item?.id)}
                    onClick={() => isItemSelectable(item) && handleSelection(item)}
                    data-testid={`${testId}.${key + 1}`}
                >
                    {safeColumns.map((col, key) => (
                        <ListCol $flex={col?.flex} $margin={col?.margin} key={key}>
                            {col?.check && <Checkbox
                                $margin='0 1rem 0 0'
                                type="checkbox"
                                checked={safeSelectedItems.some(selected => selected?.id === item?.id)}
                                onChange={() => isItemSelectable(item) && handleSelection(item)}
                                onClick={(e) => e.stopPropagation()}
                                disabled={!isItemSelectable(item)}
                            />}
                            {item?.[col?.field]} {item?.[col?.decorator]}
                            {(safeSelectedItems.some(selected => selected?.id === item?.id)) && col?.tag &&
                                <Tag $variant='primary'>{getTagValue(item)}</Tag>
                            }
                        </ListCol>
                    ))}
                </ListRow>
            ))}
            {/* The second list is the rows this document already holds — `biData`,
                the reserved partition. It had no test id until 33.2 step 6, which
                meant the split `MultiList.filterItems` performs could not be
                asserted by any spec: the only guard on the partition was that the
                available list looked right. Named separately from the available
                rows because the two are different claims. */}
            {safeBiData.map((item, key) => (
                <ListRow
                    key={key}
                    selected={safeSelectedItems.some(selected => selected?.id === item?.id)}
                    data-testid={`${testId}.reserved.${key + 1}`}
                >

                    {safeColumns.map((col, key) => (
                        <ListCol $flex={col?.flex} $margin={col?.margin} key={key}>
                            {(key === 0) ? <Tag $margin='0 1rem 0 0' $variant='primary'>R</Tag> : <></>}
                            {item?.[col?.field]} {item?.[col?.decorator]} {t(col?.label ?? '')}
                            {col?.tag && <Tag $variant='primary'>{item?.displayQuantity}</Tag>}
                        </ListCol>
                    ))}
                </ListRow>
            ))}

        </ListContainer>
    );

}

export default BaseList